import { VendaRepository } from "../repository/venda_repository";

export class VendaService {
	constructor() {
		this.vendaRepository = new VendaRepository();
	}

	async save(data) {
		return await this.vendaRepository.save(data);
	}

	async getAll(unidadeDistribuidoraId, search) {
		return await this.vendaRepository.getAll(unidadeDistribuidoraId, search);
	}

	async getById(id) {
		return await this.vendaRepository.getById(id);
	}

	async delete(id) {
		return await this.vendaRepository.delete(id);
	}

	async getProdutosDisponiveis(unidadeDistribuidoraId, produtoFinalId) {
		return await this.vendaRepository.getProdutosDisponiveis(unidadeDistribuidoraId, produtoFinalId);
	}
}
